export default [{
  path: '/home',
  component: resolve => require(['@/components/base/view/main/main.vue'], resolve),
  children: [{
    path: '/ops',
    component: resolve => require(['@/components/base/view/ops/ops.vue'], resolve) //运维中心
  }, {
    path: '/ops/cfg',
    component: resolve => require(['@/components/base/view/ops/cfg/cfg.vue'], resolve) //系统参数配制
  }, {
    path: '/ops/ecp',
    component: resolve => require(['@/components/base/view/ops/ecp/ecp.vue'], resolve) //异常查询
  }, {
    path: '/ops/log/opt',
    component: resolve => require(['@/components/base/view/ops/log/opt/opt.vue'], resolve) //操作日志
  }, {
    path: '/ops/log/error',
    component: resolve => require(['@/components/base/view/ops/log/error/error.vue'], resolve) //异常日志
  }, {
    path: '/ops/log/error/info',
    component: resolve => require(['@/components/base/view/ops/log/error/info/info.vue'], resolve) //异常日志详情
  }, {
    path: '/ops/log/sys',
    component: resolve => require(['@/components/base/view/ops/log/sys/sys.vue'], resolve) //系统日志
  }, {
    path: '/ops/help',
    component: resolve => require(['@/components/base/view/ops/help/help.vue'], resolve) //帮助文档
  }, {
    path: '/ops/menu',
    component: resolve => require(['@/components/base/view/ops/menu/menu.vue'], resolve) // 菜单管理
  }, {
    path: '/ops/db',
    component: resolve => require(['@/components/base/view/ops/db/db.vue'], resolve) //实体表列表
  }, {
    path: '/ops/service',
    component: resolve => require(['@/components/base/view/ops/service/service.vue'], resolve) //服务支持
  }]
}, {
  path: '/ops/api',
  component: resolve => require(['@/components/base/view/ops/api/api.vue'], resolve)//接口文档
}, {
  path: '*',
  component: resolve => require(['@/components/base/view/cmps/404/PageNotFound.vue'], resolve)//错误页面
}]



// WEBPACK FOOTER //
// ./src/components/base/router/ops.js